import * as productActions from '../actions/products.actions';
import { Product } from '../models/Product';

export interface IProductsState {
  products: Product[];
  loading: boolean;
  minPrice: number;
  maxPrice: number;
  lastLoadedTime: number;
  maxDistance: number;
}

export const inittialProductState: IProductsState = {
  products: [],
  loading: false,
  minPrice: 10,
  maxPrice: 1000,
  lastLoadedTime: new Date().getTime(),
  maxDistance: 55
};

export function reducer(productState: IProductsState = inittialProductState,
  action: productActions.ProductAction): IProductsState {

  switch (action.type) {

    case productActions.LOAD_PRODUCTS: {
      return {
        ...productState,
        loading: true
      };
    }

    case productActions.FETCH_PRODUCTS_FAILED: {
      return {
        ...productState,
        loading: false
      };
    }

    case productActions.LOAD_PRODUCTS_SUCCESS: {
      const maxPrice = action.payload.reduce((acc, curr) => Math.max(acc, curr.newPrice), 0);
      const minPrice = action.payload.reduce((acc, curr) => Math.min(acc, curr.newPrice), maxPrice);

       let maxDistance = 56;

      return {
        products: action.payload,
        loading: false,
        minPrice: minPrice,
        maxPrice: maxPrice,
        lastLoadedTime: new Date().getTime(),
        maxDistance: maxDistance
      };
    }

    default: {
      return productState;
    }

  }
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/reducers/product.reducer.ts